import React from "react";
import InputText1 from "../InputText1";

const SenderInformationForm = ({
  firstName, setFirstName,
  middleName, setMiddleName,
  lastName, setLastName,
  mobileNumber, setMobileNumber,
  emailAddress, setEmailAddress,
  IdPresented, setIdPresented,
  IdNumber, setIdNumber
}) => {
  return (
    <div className="padalaFormCard">
      <p className="semibold xl t-darkgray">Sender information</p>
      <div style={{ height: "20px" }}></div>
      <div className="line2"></div>
      <div style={{ height: "15px" }}></div>

      <form className="padalaForm">

        <div className="w-50">
          <InputText1
            title="First Name*"
            placeholder="First Name"
            name="firstname"
            value={firstName}
            onChange={(e)=> setFirstName(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="Middle Name"
            placeholder="Middle Name (Optional)"
            name="middleName"
            value={middleName}
            onChange={(e)=> setMiddleName(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="Last Name*"
            placeholder="Last Name"
            name="lastname"
            value={lastName}
            onChange={(e)=> setLastName(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="Mobile Number"
            placeholder="639-XXX-XXX-XXXX"
            name="mobileNumber"
            value={mobileNumber}
            onChange={(e)=> setMobileNumber(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="Email Address"
            placeholder="Optional"
            name="emailAddress"
            value={emailAddress}
            onChange={(e)=> setEmailAddress(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="ID Presented"
            placeholder="Optional"
            name="id_presented"
            value={IdPresented}
            onChange={(e)=> setIdPresented(e.target.value)}
          />
        </div>

        <div className="w-50">
          <InputText1
            title="ID Number"
            placeholder="ID Number (Optional)"
            name="id_number"
            value={IdNumber}
            onChange={(e)=> setIdNumber(e.target.value)}
          />
        </div>

      </form>
    </div>
  );
};

export default SenderInformationForm;
